<template>
    <box-model title="问答话题">
      <template v-slot:content>
        <div class="con flex-x-center">
          <div class="detail">
            <div class="question">
              <img class="q-icon" src="../../assets/img/qa/question.png" />
              <span>机械收获花生需要注意的环节有哪些？</span>
            </div>
            <div class="answer">
              <img class="a-icon" src="../../assets/img/qa/answer.png" />
              <span>适时收获。花生在收获期应做到适时收获,收获过早,达不到预期产量,效益低下,影响收入</span>
            </div>
          </div>
          <div class="opt o-left flex-center">
            <img class="o-img" src="../../assets/img/qa/left.png" />
          </div>
          <div class="opt o-right flex-center">
            <img class="o-img" src="../../assets/img/qa/right.png" />
          </div>
        </div>
      </template>
    </box-model>
</template>

<script>
  export default {
    components: {
      "box-model": () => import("../../components/common/Model.vue")
    }
  }
</script>

<style scoped lang="less">
  .con {
    width: 100%;
    .detail {
      width: 3.6rem;
      .question {
        position: relative;
        width: 100%;
        padding: .08rem .1rem .08rem .44rem;
        background: rgba(40,136,241,0.1412);
        font-size: .14rem;
        font-weight: 400;
        color: #4ADDFF;
        line-height: .24rem;
        .q-icon {
          position: absolute;
          top: .08rem;
          left: .1rem;
          width: .24rem;
          height: .24rem;
        }
      }
      .answer {
        position: relative;
        width: 100%;
        padding: .08rem .1rem .08rem .44rem;
        font-size: .14rem;
        font-weight: 400;
        color: rgba(255,255,255,0.8);
        line-height: .24rem;
        margin-top: .2rem;
        .a-icon {
          position: absolute;
          top: .08rem;
          left: .1rem;
          width: .24rem;
          height: .24rem;
        }
      }
    }
  }
  .opt {
    position: absolute;
    top: 50%;
    width: .2rem;
    height: .4rem;
    transform: translateY(-50%);
    .o-img {
      width: 100%;
      height: 100%;
    }
  }
  .o-left {
    left: .1rem;
  }
  .o-right {
    right: .1rem;
  }
</style>